import { useMemo } from "react";
import { DropdownProps, Grid, Select } from "semantic-ui-react";
import { defaultValues } from "../../../../../app_constants";
import { getSelectItemClassName } from "../../../../../shared-functions/string";

type IPVersionProps = {
  onChange: (event: React.FormEvent<HTMLElement>, data: DropdownProps) => void;
  value: string;
};

const IPVersion = ({ onChange, value }: IPVersionProps) => {
  const ipOptions = useMemo(() => {
    return defaultValues.subnet.ip_version.map((x, i) => ({
      key: x,
      value: x,
      text: `IP Ver: ${x}`,
      className: getSelectItemClassName(`IP Ver: ${x}`),
    }));
  }, []);

  return (
    <>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <h5>IP Version</h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <Select
          icon="chevron circle down"
          className="select-box full"
          placeholder="Choose IP version"
          name="ipVersion"
          value={value}
          options={ipOptions}
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};
export default IPVersion;
